import styled from 'styled-components';
import { FloatingArrow } from '@floating-ui/react';
export const TooltipArrow = styled(FloatingArrow)`
  fill: ${({ theme }) => theme.brand.secondary.darker};
`;
export const Close = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  background: none;
  border: none;
  padding: 12px 16px;
  cursor: pointer;
  //So the Close button appears on top of any text that might interact with it
  z-index: 10;
  font-size: ${({ theme }) => theme.typography.fontSizes.S12};
`;
